import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { colorsFoundation } from "../../../theme/index.js";

/**
 * StehlgutHinweise — the click-dummy's Hausrat "Empfohlene Nachweise" panel:
 * a soft accent-tinted box listing the documents that speed up a Hausrat claim
 * (Stehlgutliste, police report, receipts, photos, cost estimate).
 *
 * Presentational MDDForm control (`stehlgut_hinweise`); accepts an optional
 * `title` and `items` list, else the dummy defaults.
 */
const ACCENT = colorsFoundation.key.blue[600];
const ACCENT_TINT = colorsFoundation.key.blue[50];
const ACCENT_BORDER = colorsFoundation.key.blue[200];

const DEFAULT_ITEMS = [
  "Stehlgutliste (bei Einbruch / Raub)",
  "Polizeiliche Anzeige / Aktenzeichen",
  "Kaufbelege / Rechnungen",
  "Fotos der beschädigten Gegenstände",
  "Kostenvoranschlag / Reparaturrechnung",
];

export default function StehlgutHinweise({ item }) {
  const title = item?.title || "Empfohlene Nachweise für Hausratschäden";
  const items = item?.items || DEFAULT_ITEMS;

  return (
    <Box
      sx={{
        backgroundColor: ACCENT_TINT,
        border: `1px solid ${ACCENT_BORDER}`,
        borderRadius: "12px",
        p: "18px 20px",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: 700,
          color: colorsFoundation.gray[900],
          mb: "12px",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: "8px 20px",
        }}
      >
        {items.map((text) => (
          <Box key={text} sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 16, color: ACCENT, flex: "none" }} />
            <Typography sx={{ fontSize: "13px", color: colorsFoundation.gray[700] }}>
              {text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

StehlgutHinweise.propTypes = {
  item: PropTypes.object,
};
